angular.module('zc.commonApi')

.factory 'projectServiceRequestTransformer', ($filter) ->
  doTransform = (project) ->
    project = _.assignIn({}, project)
    project.installed_at = $filter('changeDatetimeFrom')('localToRegion', project.installed_at, 'string') if project.installed_at
    project.contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.contracted_at, 'string') if project.contracted_at
    project.terminated_at = $filter('changeDatetimeFrom')('localToRegion', project.terminated_at, 'string') if project.terminated_at
    project.trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_started_at, 'string') if project.trial_started_at
    project.trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_end_at, 'string') if project.trial_end_at
    project.lens_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_contracted_at, 'string') if project.lens_contracted_at
    project.lens_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_cancelled_at, 'string') if project.lens_cancelled_at
    project.iw_trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_started_at, 'string') if project.iw_trial_started_at
    project.iw_trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_end_at, 'string') if project.iw_trial_end_at
    project.iw_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_cancelled_at, 'string') if project.iw_cancelled_at
    project.iw_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_contracted_at, 'string') if project.iw_contracted_at
    project

  return (data) ->
    if data.project
      data.project = doTransform(data.project)

    return JSON.stringify(data)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/project_request.transformer.js.coffee